__turbopack_context__.v({
  "flex-row": "styles-module__Mf3eHq__flex-row",
  "form": "styles-module__Mf3eHq__form",
  "search-controls-wrapper": "styles-module__Mf3eHq__search-controls-wrapper",
  "search-result-ol": "styles-module__Mf3eHq__search-result-ol",
  "search-result-ul": "styles-module__Mf3eHq__search-result-ul",
  "search-results-wrapper": "styles-module__Mf3eHq__search-results-wrapper",
  "search-suggestions-wrapper": "styles-module__Mf3eHq__search-suggestions-wrapper",
  "search-wrapper": "styles-module__Mf3eHq__search-wrapper",
});
